import React, { Component } from 'react';
 
export default class ForgotPassword extends Component {

    render() {
        return window.location.href = 'https://ultimatesprodev.b2clogin.com/ultimatesprodev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_PasswordReset&client_id=bd0f0ab0-7788-42be-99d7-e2afd5b69014&nonce=defaultNonce&redirect_uri='+ encodeURIComponent(window.location.origin) +'&scope=openid&response_type=id_token&prompt=login'; 
        //null;
    }
}
